import { addGETParams } from '../../config'
import ax from '../api'
/**
 * uploadImage uploads an image to the server.
 *
 * @param {FormData} formData - A FormData instance containing the image file under the 'file' key.
 * @param {object} [config={}] - Optional Axios request configuration (e.g., onUploadProgress).
 * @returns {Promise<import('axios').AxiosResponse>} The full Axios response object.
 * @throws {Error} When the upload fails, with a message including the underlying error.
 */
export const uploadImage = async (formData, config = {}) => {
	try {
		const response = await ax.post('/images/upload-image.php', formData, {
			headers: { 'Content-Type': 'multipart/form-data' },
			...config
		})
		return response // Ensure this returns the whole response object
	} catch (error) {
		throw new Error(`uploadImage() Upload failed: ${error.message}`)
	}
}

/**
 * getImageUrl retrieves the URL or metadata for an uploaded image.
 *
 * @param {object} params - Query parameters to include in the GET request.
 * @returns {Promise<any>} The parsed response data from the server.
 */
// not used yet
export const getImageUrl = async (params) => {
	const _url = addGETParams(`/images/get-image.php`, params)

	const { data } = await ax.get(_url)
	return data
}
